import React, { useMemo } from "react";
import classnames from "classnames";
import moment from "moment";

const ActiveUntil = ({ date }) => {
  const [daysValue, after] = useMemo(() => {
    let days;
    let after = "";

    if (date) {
      const now = moment().startOf("day");
      const activeUntil = moment(date);
      days = activeUntil.diff(now, "days");
      if (days < 0) {
        days = 0;
      }

      after = "дней";
    } else {
      days = "Не указано";
    }

    return [days, after];
  }, [date]);

  const red = daysValue == 1;

  return (
    <div className={classnames("teaser__meta-row", { red })}>
      <span>Осталось: </span>
      <span>
        {daysValue} {after}
      </span>
    </div>
  );
};

export default ActiveUntil;
